export default {
    isAdmin: (state) => {
        return state.user && state.user.role.length && state.user.role[0].name === 'ADMIN';
    },
};
